export default function StructuredData({ data }) {
  if (!data) return null;

  const items = Array.isArray(data) ? data : [data];

  return items.map((item, index) => (
    <script
      key={`${item["@type"] || "structured-data"}-${index}`}
      type="application/ld+json"
    >
      {JSON.stringify(item)}
    </script>
  ));
}
